import * as yup from 'yup';
import { twoDecimalNumbersSchema } from './common';

export const estimatesSchema = yup.object({
  estimatedBins: twoDecimalNumbersSchema,
});
